import { Injectable } from '@angular/core';
import { AuthenticationService } from 'libs/data/src/lib/services/auth/authentication.service';
import { menu } from './menu';
import { CookieService } from 'ngx-cookie-service';
import { Subject } from 'rxjs';
import { superAdminRoleStr } from '@piqet-angular/shared';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  menuItems: Array<any> = [];
  sideMenuItems: Array<any> = [];
  accessRoleJson: any;
  customMenu: any;
  decodeUserRole: any;
  private menuSubject = new Subject<void>();
  menuAction$ = this.menuSubject.asObservable();
  private accessRolesLoaded = false;
  constructor(private cookieService: CookieService, private sharedService: SharedService) {}

  async initializeMenu() {
    this.menuItems = [];
    this.sideMenuItems = [];
    await this.getAccess(); // Ensure access roles are loaded first
    this.accessRolesLoaded = true;
    await this.setMenu();
  }

  triggerSetMenu() {
    this.menuSubject.next();
  }

  updateMenu() {
    this.menuItems = [];
    this.setMenu(true);
  }

  async setMenu(flag?: boolean) {
    // if (!this.accessRolesLoaded) {
    //   await this.getAccess();
    //   this.accessRolesLoaded = true;
    // }
    if (!this.menuItems.length) {
      const userRole = this.cookieService.get('u_type');
      this.decodeUserRole = this.sharedService.decodeURIComponentParam(userRole)?.toLowerCase();
      let menuItem: any = [...menu];
      if (this.decodeUserRole != superAdminRoleStr) {
        menuItem = menuItem.filter((item: any) => item.text !== 'Administrator');
      }
      await this.addMenu(menuItem);
      // this.triggerSetMenu();
    }
  }

  async getAccess() {
    const token = this.cookieService.get('token');
    if (token) {
      try {
        await new Promise(resolve => setTimeout(resolve, 100));
        const accessRole: any =
          localStorage.getItem('access') || localStorage.getItem('access') !== 'undefined'
            ? localStorage.getItem('access')
            : undefined;
        this.accessRoleJson = accessRole ? JSON.parse(accessRole) : [];
      } catch (error) {
        console.error('Failed to get access roles', error);
        this.accessRoleJson = [];
      }
    } else {
      this.accessRoleJson = [];
    }
  }

  async addMenu(
    itemCopy: any = Array<{
      text: string;
      accessString: string;
      link?: string;
      icon?: string;
      submenu?: Array<any>;
    }>
  ) {
    const items = itemCopy.length ? itemCopy : menu;
    if (!this.accessRolesLoaded) {
      // await this.getAccess();
      this.accessRolesLoaded = true;
    }

    if (!this.menuItems.length) {
      items.forEach((item: any) => {
        // Special handling for Projects menu
        // if (item.text.toLowerCase() === 'projects') {
        //   const projectAccess = this.accessRoleJson?.find((data: any) =>
        //     data.moduleName?.toLowerCase() === 'projects'
        //   );

        //   // If Projects module exists and isOverview is false, skip this menu item
        //   if (projectAccess && !projectAccess.isOverview) {
        //     return; // Skip adding this menu item
        //   }
        // }

        if (item.submenu && item.text.toLowerCase() !== 'projects') {
          // Handle first level submenu
          item.submenu = item?.submenu?.map((el: any) => {
            const menuAccess = this.getMainMenuOverview(el, item);
            return {
              ...el,
              isAccess: this.isSuperAdmin() || menuAccess || item.text.toLowerCase() === 'help',
            };
          });

          // Handle nested submenus
          item.submenu.forEach((childItem: any) => {
            if (childItem.submenu) {
              childItem.submenu = childItem?.submenu?.map((childEl: any) => {
                const submenuAccess = this.getSubMenuOverview(childEl, childItem);
                return {
                  ...childEl,
                  isAccess:
                    this.isSuperAdmin() || submenuAccess || item.text.toLowerCase() === 'help',
                };
              });

              // Handle third level submenus
              childItem.submenu.forEach((subChildItem: any) => {
                if (subChildItem.submenu) {
                  subChildItem.submenu = subChildItem?.submenu?.map((subchildEl: any) => {
                    const subsubmenuAccess = this.getSubMenuOverview(subchildEl, subChildItem);
                    return {
                      ...subchildEl,
                      isAccess:
                        this.isSuperAdmin() ||
                        subsubmenuAccess ||
                        item.text.toLowerCase() === 'help',
                    };
                  });
                  subChildItem.isAccess = this.hasAccessibleChildren(subChildItem.submenu);
                }
              });
              childItem.isAccess = this.hasAccessibleChildren(childItem.submenu);
            }
          });
        }

        // Set main menu item access
        if (!this.accessRoleJson || !this.accessRoleJson.length) {
          item.isAccess =
            item.hasOwnProperty('submenu') && !item.hideForNav
              ? this.hasAccessibleChildren(item.submenu)
              : true;
        } else {
          if (item.text.toLowerCase() === 'projects') {
            item.isAccess = this.checkProjectAccess();
          } else {
            item.isAccess = item.hasOwnProperty('submenu')
              ? this.hasAccessibleChildren(item.submenu)
              : true;
          }
        }

        if (item.isAccess) {
          this.menuItems.push(item);
        }
      });
    }
  }

  private isSuperAdmin(): boolean {
    return this.decodeUserRole === superAdminRoleStr;
  }

  private hasAccessibleChildren(submenu: any[]): boolean {
    return submenu?.some((item: any) => item.isAccess) ?? false;
  }

  private checkProjectAccess(): boolean {
    if (this.isSuperAdmin()) return true;

    // First check if Projects module exists and has isOverview false
    // const projectModule = this.accessRoleJson?.find((data: any) =>
    //   data.moduleName?.toLowerCase() === 'projects'
    // );

    // if (projectModule && !projectModule.isOverview) {
    //   return false;
    // }

    if (!this.accessRoleJson?.length) return true;
    return this.accessRoleJson.some(
      (data: any) =>
        // ['package scenario', 'product scenario', 'productpackgesystem scenario'].includes(data.moduleName?.toLowerCase()) &&
        (data.moduleName?.toLowerCase() === 'packaging' && data.isOverview) ||
        (data.moduleName?.toLowerCase() === 'product' && data.isOverview)
    );
  }

  getMainMenuOverview(element: any, item: any) {
    return this.accessRoleJson?.some(
      (data: any) =>
        data.moduleName?.toLowerCase() === element.text?.toLowerCase() &&
        data.parentModuleName?.toLowerCase() === item.text.toLowerCase() &&
        data.isOverview
    );
  }

  getSubMenuOverview(childElement: any, childItem: any) {
    return this.accessRoleJson?.some(
      (data: any) =>
        data.moduleName?.toLowerCase().trim() === childElement.text?.toLowerCase().trim() &&
        data.parentModuleName?.toLowerCase().trim() === childItem.text.toLowerCase().trim() &&
        data.isOverview
    );
  }

  async getMenu() {
    await this.initializeMenu();
    return this.menuItems;
  }

  getSideMenu() {
    return this.sideMenuItems;
  }

  clearMenu() {
    this.menuItems = [];
    this.sideMenuItems = [];
  }

  addSideMenu(items: Array<any>) {
    items.forEach((item: any) => {
      if (item.isAccess) {
        this.sideMenuItems.push(item);
      }
    });
  }
}
